import React, { FunctionComponent, useMemo } from 'react';

import { ConfigItem, ConfigItemType } from '../types';

import { SelectElement } from './SelectElement';
import { NumericRangeElement } from './NumericRangeElement';
import { MultiSelectElement } from './MultiSelectElement';
import { ConfigItemElementProps } from './types';
import { DateRangeElement } from './DateRangeElement';
import { ConfigGroupElement } from './ConfigGroupElement';
import { ConfigItemsTrayContext } from './ConfigItemsTrayContext';
import { MultiCellElement } from './MultiCellElement';
import { DataTypeControlElement } from './DataTypeControlElement';
import { ContextSelectorElement } from './ContextSelectorElement';

const configElements: Record<ConfigItemType, FunctionComponent<ConfigItemElementProps<ConfigItem>>> = {
  select: SelectElement,
  multiSelect: MultiSelectElement,
  numericRange: NumericRangeElement,
  dateRange: DateRangeElement,
  multiCell: MultiCellElement,
  dataTypeControl: DataTypeControlElement,
  group: ConfigGroupElement,
  contextSelector: ContextSelectorElement,
};

type Props = {
  children: React.ReactNode;
  /**
   * If true, context is used for the multi edit insights page.
   */
  isMultiEditPage?: boolean;
};

function ConfigItemsTrayContextProvider({ children, isMultiEditPage = false }: Props) {
  const value = useMemo(() => ({ configElements, isMultiEditPage }), [isMultiEditPage]);
  return <ConfigItemsTrayContext.Provider value={value}>{children}</ConfigItemsTrayContext.Provider>;
}

export { ConfigItemsTrayContextProvider };
